module.exports = __webpack_public_path__ + "media/images/orientation_logo-d2eddee9b8023e042decb97cb16ecb41.png";